const ACCEPTANCE_STATUS_ID = 3;

const uniqueErrorMessage =
  'Все выбранные помещения должны находиться на одной стадии жизненного цикла';
const acceptanceErrorMessage =
  'Все выбранные помещения находятся в стадии «Приемка». Менять им стадии и этапы можно только в модуле «Приемки»';

const useValidateFlatsStage = ({ flats = [], entity }) => {
  if (!flats.length) return uniqueErrorMessage;

  const getStageId = (flat) =>
    flat?.addressLifeCycle?.stageAddressLifeCycle?.id ?? null;

  const stageIds = flats.map(getStageId);

  if (stageIds.some((id) => !id)) return uniqueErrorMessage;

  const unique = new Set(stageIds);

  if (unique.size === 1) {
    const hasAcceptance = unique.has(ACCEPTANCE_STATUS_ID);

    return hasAcceptance && entity === 'lifeCycle'
      ? acceptanceErrorMessage
      : undefined;
  }

  return uniqueErrorMessage;
};

export default useValidateFlatsStage;
